module.exports = __webpack_public_path__ + "static/img/14.c8a753c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/14.png
// module id = NMey
// module chunks = 0